export const NP_DOMAIN = __PROD__
  ? 'https://npcoins.indiatimes.com'
  : 'https://nprelease.indiatimes.com';

export const campaingHistoryNameWEB = __PROD__
  ? 'campaign7514741'
  : 'campaign233904';
export const campaingHistoryNameWAP = __PROD__
  ? 'campaign4261891'
  : 'campaign8133461';

export const fetchAllActivitiesMapping = isWap =>
  __PROD__
    ? {
        read: 'act4045258',
        watch_video: 'act4115679',
        dailycheckin: isWap ? 'act5410818' : 'act5385770',
        listen_podcast: 'act3054357',
        prime_free_trial: 'act3306478',
        prime_paid_subscription: 'act1326237',
        checkInBonus: isWap ? 'act5346696' : 'act5301048',
        comment: 'act4276334',
      }
    : {
        read: 'act1467057',
        watch_video: 'act1716334',
        dailycheckin: isWap ? 'act7787289' : 'act3532482',
        listen_podcast: 'act3112770',
        prime_free_trial: 'act2777703',
        prime_paid_subscription: 'act1149461',
        checkInBonus: isWap ? 'act7881767' : 'act3862764',
        comment: 'act2753794',
      };
